import { Combobox, Transition } from '@headlessui/react';
import { Fragment, useState } from 'react';

interface Props {
  placeholder?: string;
}

const values = [
  { id: 1, value: 'Durward Reynolds' },
  { id: 2, value: 'Kenton Towne' },
  { id: 3, value: 'Therese Wunsch' },
  { id: 4, value: 'Benedict Kessler' },
  { id: 5, value: 'Katelyn Rohan' },
  { id: 6, value: 'Benedict Kessler' },
  { id: 7, value: 'Katelyn Rohan' },
  { id: 8, value: 'Benedict Kessler' },
  { id: 9, value: 'Katelyn Rohan' }
];

function InputCombo({ placeholder = '' }: Props) {
  // https://headlessui.com/react/combobox
  // logic is incomplete, just placeholder for UI presentation
  const [selectedValue, setSelectedValue] = useState('');
  const [query, setQuery] = useState('');

  const filteredValues =
    query === ''
      ? values
      : values.filter((item) =>
          item.value
            .toLowerCase()
            .includes(query.toLowerCase())
        );
  return (
    <Combobox
      value={selectedValue}
      onChange={(value) => setSelectedValue(value)}
    >
      <div className="relative">
        <Combobox.Input
          placeholder={placeholder}
          onChange={(event) => setQuery(event.target.value)}
          className="w-full rounded-xl border-2 border-sl-blue border-opacity-25 py-2.5 px-4 font-circular text-base font-normal text-sl-blue-dark placeholder-sl-blue-dark placeholder-opacity-25 transition-colors duration-300 placeholder:transition-colors focus:border-opacity-100 focus:placeholder-opacity-50 focus:outline-none md:text-lg "
        />
        <Transition
          as={Fragment}
          leave="transition ease-in duration-100"
          enter="transition ease-in duration-100"
          enterFrom="opacity-0 -transform-y-3"
          enterTo="opacity-100 transform-y-0"
          leaveFrom="opacity-100 transform-y-0"
          leaveTo="opacity-0 -transform-y-3"
          afterLeave={() => setQuery('')}
        >
          <Combobox.Options className="absolute z-50 mt-1 max-h-40 w-full overflow-auto rounded-md bg-white text-left text-sm text-sl-blue text-opacity-60 shadow-lg focus:outline-none">
            {filteredValues.map((item) => (
              <Combobox.Option
                key={item.id}
                value={item.value}
                className="bg-white"
              >
                {({ active, selected }) => (
                  <span
                    className={`block cursor-pointer py-1 px-3 ${
                      active || selected
                        ? 'bg-sl-indigo bg-opacity-10 text-opacity-100'
                        : 'text-opacity-75'
                    }`}
                  >
                    {item.value}
                  </span>
                )}
              </Combobox.Option>
            ))}
          </Combobox.Options>
        </Transition>
      </div>
    </Combobox>
  );
}

export default InputCombo;
